import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { FeatureCollection } from '@turf/turf';

export type BtnUploadResponse = {
  id: string;
  ext: string;
  originalName: string;
  storedPath?: string;
  queuedRows?: number;
  status: string;
};

export type BtnImportFile = {
  id: string;
  boardId: string;
  ext: string;
  originalName: string;
  status: 'in_progress' | 'done' | string;
  totalRows: number;
  handledRows: number;
  createdAt: string;
  progressPercent?: number;
};

export type BtnImportRow = {
  id: string;
  importFile: string;
  address: string | null;
  lat: number | null;
  lng: number | null;
  handled: boolean;
  result: string;
  retryCount: number;
  lastAttemptAt: string | null;
  plotId?: number;
  plotUuid?: string;
  [key: string]: any;
};

export type BtnImportState = {
  files: BtnImportFile[];
  rows: BtnImportRow[];
};

@Injectable({ providedIn: 'root' })
export class BtnApiService {
  private readonly baseUrl = `${environment.apiUrl}/api/btn`;

  constructor(private http: HttpClient) {}

  upload(file: File, boardId: string): Observable<BtnUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('boardId', boardId);
    return this.http.post<BtnUploadResponse>(`${this.baseUrl}/upload`, formData);
  }

  getFilesProgress(boardId: string): Observable<BtnImportState> {
    return this.http
      .get<BtnImportFile[]>(`${this.baseUrl}/files-progress/${boardId}`)
      .pipe(map((files) => ({ files, rows: [] })));
  }

  getImportFileRows(fileId: string): Observable<BtnImportRow[]> {
    return this.http.get<BtnImportRow[]>(`${this.baseUrl}/file-rows/${fileId}`);
  }

  getMatchedPoints(fileId: string): Observable<FeatureCollection> {
    return this.http.get<FeatureCollection>(`${this.baseUrl}/matched-points/${fileId}`);
  }

  exportFile(fileId: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/export/${fileId}`, {
      responseType: 'blob',
    });
  }
}


